export default {"src":"/_next/static/media/Agritech.179c4a89.svg","height":44,"width":44};